<template>
  <div class="input-datepicker">
    <b-datepicker
      pack="fas"
      icon="calendar"
      :required="required"
      :day-names="dayNames"
      :month-names="monthNames"
      :date-formatter="dateFormatter"
      :value="value"
      :class="inputClasses"
      @input="(value) => $emit('input', value)"
    />
    <div v-if="validator && validator.$error">
      <ul
        v-for="(value, key) in validationsMessage"
        :key="key"
        class="input-error"
      >
        <li v-if="!validator[key]">
          {{ value }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from "moment";

const today = new Date();

export default {
  props: {
    value: {
      type: Date,
      default: new Date(),
    },
    error: Boolean,
    classCustom: String,
    required: { default: false },
    placeholder: String,
    validationsMessage: {
      type: Object,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dayNames: ["D", "Sg", "T", "Qt", "Q", "S", "Sb"],
      monthNames: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    };
  },
  computed: {
    inputClasses() {
      return [
        this.classCustom
          ? this.classCustom
          : "w-full block tracking-wide text-gray-700 text-xs focus:outline-none focus:bg-white focus:border-gray-500",
        this.error ? "fail-error" : "border",
      ];
    },
  }, // data
  mounted: function () {
    this.minDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
  }, // mounted
  methods: {
    dateFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  }, // methods
};
</script>
